import React from "react";
import classes from "./RelatedItems.module.css";
import { useNavigate } from "react-router-dom";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";

const RelatedItems = ({ data }) => {
  const navigate = useNavigate();
  const width = useDeviceWidth();
  const sliceAmount = width > 1800 ? 4 : width > 1380 ? 3 : 4;

  return (
    <div className={classes.outer}>
      <h1 data-aos="fade-right" data-aos-delay="200">
        Related Services
      </h1>
      <div className={classes.list}>
        {data?.slice(0, sliceAmount)?.map((item, index) => (
          <div
            className={classes.card}
            // data-aos="fade-right"
            // data-aos-delay={index * 10 + 100}
            onClick={() => navigate(`/services/${item?.slug}`)}
          >
            <img src={item?.image?.url} alt={item?.image?.imageTag}></img>
            <div className={classes.rightDiv}>
              <h2>{item?.title}</h2>
              <div className={classes.underLine}></div>
              <p>{item?.shortDescription}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedItems;
